/**
 * Lookbehind é um recurso de Regex usado para verificar o que aparece
 * antes de determinado trecho, sem incluir essa parte no resultado encontrado.
 *
 * O sistema utiliza Lookbehind, portanto o navegador precisa ser compatível
 * com esse recurso para executar a aplicação.
 */

export const BROWSER_MINIMUM_VERSION = {
  // Chrome 109 — 10/01/2023
  chrome: '>=109',

  // Edge 109 — 12/01/2023
  edge: '>=109',

  // Firefox 109 — 17/01/2023
  firefox: '>=109',

  // Opera 95 — 01/02/2023
  opera: '>=95',

  // Safari 16.4 — 27/03/2023
  safari: '>=16.4',
} as const

/**
 * iOS/iPadOS e Safari no macOS precisam utilizar uma versão
 * compatível com o WebKit que suporta Lookbehind.
 */
export const APPLE_MINIMUM_VERSION = '>=16.4'

export type SupportedBrowser = keyof typeof BROWSER_MINIMUM_VERSION
